<template>
  <div class="contenedor-graf">
    <h3 class="titulo">
      ¿Cuántos son hombres y mujeres?
      <span class="dHombres">Desaparición de hombres</span>,
      <span class="dMujeres">desaparición de mujeres</span>,
      <span class="hHombres">homicidio de hombres</span> y
      <span class="hMujeres">homicidio de mujeres</span> del 2006 al 2022
    </h3>
    <text class="instrucciones"
      >Coloca el cursor sobre las barras para obtener más detalles</text
    >

    <div id="tooltip">
      <p>
        En
        <span class="highlight">{{ entidad_tooltip }} </span>, el total de
        registros de desaparición y homicidio es de
        <span class="highlight"
          >{{ d3.format(",")(registrostotales_tooltip) }} </span
        >. <br />
        El
        <span class="highlight">{{ Math.round(valor_tooltip) }}%</span>
        corresponde a
        <span class="highlight">{{ categoria_tooltip }}</span>
      </p>
    </div>
    <svg
      id="stackedBars"
      :width="ancho + margenes.derecha + margenes.izquierda"
      :height="alto_svg"
    >
      <g
        class="eje-x"
        :transform="`translate(${margenes.izquierda},${
          alto + margenes.arriba
        })`"
      ></g>
      <g
        class="eje-y"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="barras"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
    </svg>
  </div>
</template>
<script setup>
import * as d3 from "d3";
import data_registros from "@/assets/registros.json";
import { ref, onMounted, toRefs, onUnmounted, watch } from "vue";

// eslint-disable-next-line
const props = defineProps({
  datos: {
    type: Array,
    default: Array,
  },
  region: {
    type: String,
    default: String,
  },
});
const { datos } = toRefs(props);
/* const { region } = toRefs(props); */
const registros = ref(data_registros);

const dict_color = {
  prcntg_desaparicion_hombres: "#ED594A",
  prcntg_desaparicion_mujeres: "#8B7693",
  prcntg_homicidios_hombres: "#6A9297",
  prcntg_homicidios_mujeres: "#D0A74E",
};
//const lista_colores = ["#C70039", "#485696", "#F1F188", "#FC7A1E"];
const categorias = [
  "prcntg_desaparicion_hombres",
  "prcntg_desaparicion_mujeres",
  "prcntg_homicidios_hombres",
  "prcntg_homicidios_mujeres",
];

const catKeys = {
  prcntg_desaparicion_hombres: "desaparición de hombres",
  prcntg_desaparicion_mujeres: "desaparición de mujeres",
  prcntg_homicidios_hombres: "homicidio de hombres",
  prcntg_homicidios_mujeres: "homicidio de mujeres",
};

const entidades = ref();
const stackedData = ref();

const contenedor_svg = ref();
const svg = ref();
const ancho = ref(0);
const alto_svg = ref(400);
const alto = ref(0);
const margenes = ref({
  derecha: 5,
  izquierda: 53,
  abajo: 45,
  arriba: 20,
});

const grupo_barras = ref();
const eje_x = ref();
const eje_y = ref();
const escala_x = ref();
const escala_y = ref();
const texto_x = ref();
const texto_y = ref();

const el_tooltip = ref();
const entidad_tooltip = ref();
const categoria_tooltip = ref();
const valor_tooltip = ref();
const registrostotales_tooltip = ref();

onMounted(() => {
  //console.log(datos.value);
  contenedor_svg.value = document.querySelector(".contenedor-graf");
  svg.value = d3.select("svg#stackedBars");
  eje_x.value = svg.value.select("g.eje-x");
  eje_y.value = svg.value.select("g.eje-y");
  grupo_barras.value = svg.value.select("g.barras");
  texto_x.value = svg.value.append("text").attr("text-anchor", "end");
  texto_y.value = svg.value.append("text").attr("text-anchor", "end");

  el_tooltip.value = d3.select("div#tooltip");

  entidades.value = datos.value.map((d) => d.entidad);
  stackedData.value = d3.stack().keys(categorias)(datos.value);

  dimensionando();
  dibujanding();
  window.addEventListener("resize", reescalanding);
});
onUnmounted(() => {
  window.removeEventListener("resize", reescalanding);
});
watch(datos, () => {
  //console.log(datos.value);
  entidades.value = datos.value.map((d) => d.entidad);
  stackedData.value = d3.stack().keys(categorias)(datos.value);
  //console.log(stackedData.value);
  dimensionando();
  dibujanding();
});

function reescalanding() {
  dimensionando();
  dibujanding();
}

function dimensionando() {
  ancho.value =
    contenedor_svg.value.clientWidth -
    margenes.value.derecha -
    margenes.value.izquierda;
  alto.value = alto_svg.value - margenes.value.arriba - margenes.value.abajo;

  escala_x.value = d3
    .scaleBand()
    .domain(datos.value.map((d) => d.entidad))
    .range([0, ancho.value])
    .paddingInner(0.03)
    .paddingOuter(0.03);
  escala_y.value = d3.scaleLinear().domain([0, 100]).range([alto.value, 0]);

  eje_y.value.call(d3.axisLeft(escala_y.value).tickFormat((d) => d + "%"));
  eje_x.value
    .call(d3.axisBottom(escala_x.value))
    .selectAll("text")
    .attr("font-size", 9);
  //Change the anchor point of rotation
  //.attr("text-anchor", "end");

  texto_x.value
    .attr("x", ancho.value / 2 + margenes.value.izquierda)
    .attr("y", alto.value + margenes.value.arriba + margenes.value.abajo - 10)
    .text("Entidad federativa")
    .attr("text-anchor", "middle")
    .attr("font-size", "14")
    .attr("font-weight", "bold");

  texto_y.value
    .attr("transform", "rotate(-90)")
    .attr("y", 13)
    .attr("x", -20)
    .attr("font-size", "14")
    .attr("font-weight", "bold")
    .text("Porcentaje de registros de homicidio y desaparición");
}

function dibujanding() {
  //console.log("Se triggereó dibujanding");
  grupo_barras.value
    .selectAll("g")
    .data(stackedData.value)
    .join("g")
    .style("fill", (d) => dict_color[d.key])
    .attr("fill-opacity", "0.8")
    .selectAll("rect")
    .data((d) => d)
    .join("rect")
    .attr("class", "cat_individual")
    .attr("x", (d) => escala_x.value(d.data.entidad))
    .attr("y", (d) => escala_y.value(d[1]))
    .attr("height", (d) => escala_y.value(d[0]) - escala_y.value(d[1]))
    .attr("width", escala_x.value.bandwidth())
    .on("mouseover", abrirTooltip)
    .on("mousemove", ajustarPosicionTooltip)
    .on("mouseleave", cerrarTooltip);
  // El tooltip
  el_tooltip.value.attr("class", "tultip").style("visibility", "hidden");
}

var abrirTooltip = function () {
  let currentCategoria = d3.select(this.parentNode).datum().key;
  let currentEntidad = d3.select(this).datum().data.entidad;
  let currentCatValue = d3.select(this).datum().data[currentCategoria];
  let currenTotal = registros.value[currentEntidad]["total_registros"];

  entidad_tooltip.value = registros.value[currentEntidad]["entidad"];
  categoria_tooltip.value = catKeys[currentCategoria];
  valor_tooltip.value = currentCatValue.toFixed(2);
  registrostotales_tooltip.value = currenTotal;

  el_tooltip.value.style("visibility", "visible").selectAll("text");
};
var ajustarPosicionTooltip = function () {
  //console.log(d3.pointer(event, document.body));

  let x_position = 0;
  if (d3.pointer(event, document.body)[0] + 75 > ancho.value - 50) {
    x_position = d3.pointer(event, document.body)[0] - 110;
  } else {
    x_position = d3.pointer(event, document.body)[0] + 30;
  }
  el_tooltip.value
    .style("left", x_position + "px")
    .style("top", d3.pointer(event, document.body)[1] + "px");
};
var cerrarTooltip = function () {
  el_tooltip.value.style("visibility", "hidden");
};
</script>
<style scoped>
.tultip {
  position: absolute;
  z-index: 2;
  background-color: #252323;
  color: white;
  opacity: 0.93;
  height: auto;
  width: 100px;
  font-size: 14px;
  padding: 5px;
}
.titulo {
  margin-bottom: 0;
  padding-bottom: 5px;
  color: black;
}
.instrucciones {
  font-size: 14px;
  font-weight: bold;
}
.highlight {
  font-weight: bold;
}
.codigo {
  display: flex;
  flex-wrap: wrap;
}
.dHombres {
  color: #ed594a;
  width: 100px;
}
.dMujeres {
  color: #8b7693;
  width: 100px;
}
.hHombres {
  color: #6a9297;
  width: 100px;
}
.hMujeres {
  color: #d0a74e;
  width: 100px;
}
.nota-pie {
  font-size: 12px;
  padding: 3px;
  margin: 0;
}
</style>
